import { z } from 'zod';
import { idSchema, isoDateTimeSchema } from './common.js';
export const mailWorkspaceSchema = z.enum(['ALL_ACCESSIBLE', 'TENANT_BUSINESS', 'ACCOUNT']);
export const mailWorkflowScopeSchema = z
    .object({
    workspace: z.enum(['TENANT_BUSINESS', 'ACCOUNT']),
    accountId: idSchema.optional(),
})
    .strict();
export const mailWorkStatusSchema = z.enum(['OPEN', 'IN_PROGRESS', 'DONE']);
export const mailWorkflowPersonSchema = z
    .object({ id: idSchema, name: z.string().min(1) })
    .strict();
export const mailWorkflowStateSchema = mailWorkflowScopeSchema
    .extend({
    messageId: idSchema,
    read: z.boolean(),
    status: mailWorkStatusSchema,
    version: z.number().int().nonnegative(),
    assignedTo: mailWorkflowPersonSchema.nullable(),
    canEdit: z.boolean(),
    updatedAt: isoDateTimeSchema.nullable(),
})
    .strict();
export const mailWorkflowReadSchema = mailWorkflowScopeSchema
    .extend({ read: z.boolean() })
    .strict();
export const mailWorkMutationSchema = mailWorkflowScopeSchema
    .extend({
    version: z.number().int().nonnegative(),
    reason: z.string().trim().min(3).max(1000),
    status: mailWorkStatusSchema.optional(),
    assignedToId: idSchema.nullable().optional(),
})
    .strict();
export const mailWorkflowScopesSchema = z
    .object({ data: z.array(mailWorkflowScopeSchema.extend({ label: z.string() })) })
    .strict();
export const mailWorkflowChoiceQuerySchema = z
    .object({
    q: z.string().trim().max(200).optional(),
    after: idSchema.optional(),
    limit: z.coerce.number().int().min(1).max(50).default(25),
    workspace: z.enum(['ALL_ACCESSIBLE', 'TENANT_BUSINESS', 'ACCOUNT']).optional(),
    accountId: idSchema.optional(),
})
    .strict();
export const mailWorkflowChoicesSchema = z
    .object({
    data: z.array(z.object({ id: idSchema, label: z.string() }).strict()),
    nextCursor: idSchema.nullable(),
})
    .strict();
//# sourceMappingURL=mail-workflow.js.map